import { addError, addSuccess } from '@actions/utils';
import { dockerApi } from '@api/docker';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useRedux } from 'use-redux';

const Docker = () => {
  const [, dispatch] = useRedux();
  const [stats, setStats] = useState<any>({
    server: new Date(),
    balancer: new Date(),
  });

  const updateStats = () => {
    dockerApi.getStats().then(data => setStats(data));
  };

  useEffect(() => {
    updateStats();
  }, []);

  return (
    <div className="container">
      {Object.keys(stats).map(x => (
        <div key={x} style={{ display: 'flex', gap: 20, paddingTop: 16 }}>
          <button
            disabled={moment(new Date()).diff(stats[x], 'seconds') < 120}
            onClick={() => {
              setStats({
                ...stats,
                [x]: new Date(),
              });
              dockerApi.restart(x).then(
                () => {
                  dispatch(addSuccess());
                  updateStats();
                },
                () => {
                  dispatch(
                    addError(
                      'Cannot restart server! Ask for help from tech support.'
                    )
                  );
                }
              );
            }}
          >
            Restart
          </button>
          <b style={{ flexBasis: 60 }}>{x}:</b> {moment(stats[x]).fromNow()}
        </div>
      ))}
    </div>
  );
};

export default Docker;
